<div class="page status-page">
  <div class="status-card error">
    <img src="/assets/icons/circle-error-check-thin.svg" alt="error" class="flex w-[108px] h-[108px] m-auto mb-10">
    <h1>對不起！發生了一些錯誤。</h1>
    <p>{{ errMsg }}</p>
    <a [routerLink]="resumeLink">回到註冊頁面</a>
  </div>
</div>
